const Selector = ({
  title,
  setter,
  value,
  options,
  defaultValue = "",
  defaultText = "Todos",
  width = "w-[10rem]",
  disabled = false,
  compact = false,
}) => {
  const selectClass = compact
    ? "text-xs border border-gray-200 rounded-lg bg-white w-full focus:outline-none focus:ring-2 focus:ring-orange-300 cursor-pointer text-gray-700 px-2 py-1"
    : `text-gray-700 hover:cursor-pointer ${width} text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10`

  const wrapperClass = compact
    ? "w-full"
    : "flex flex-row text-xs text-gray-700 items-center justify-center gap-4"

  return (
    <div className={wrapperClass} onClick={compact ? (e) => e.stopPropagation() : undefined}>
      {!compact && <span className="whitespace-nowrap">{title}:</span>}
      <select
        value={value}
        onChange={(e) => setter(e.target.value)}
        className={selectClass}
        disabled={disabled}
        onClick={compact ? (e) => e.stopPropagation() : undefined}
      >
        {defaultValue && (
          <option value={defaultValue}>{defaultText}</option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  )
}

export default Selector;